import React, { useContext } from "react";
import { MdAdd } from "react-icons/md";
import COLORS from "scss/colors.module.scss";
import styled, { css } from "styled-components";
import { observer } from "mobx-react";
import { ContainerStoreContext } from "../ContainerStore";

function Form() {
  const containerStore = useContext(ContainerStoreContext);
  const view = containerStore?.view;
  const list = containerStore?.listConfig?.list;

  const getFormButtonText = () => {
    let buttonText =
      list.add_button_text != "" && list.add_button_text != "new entry"
        ? list.add_button_text
        : "Form - New Entry";
    return buttonText;
  };

  if (!containerStore.permissions.canAdd()) {
    return <div></div>;
  }

  return (
    <StyledFormButton
      onClick={() => {
        containerStore.showForm("New", "");
      }}
    >
      <MdAdd size={18} />
      <StyledFormTitle>
        {getFormButtonText() == "New Entry" ? "Form" : getFormButtonText()}
      </StyledFormTitle>
    </StyledFormButton>
  );
}

const StyledFormButton = styled.div`
  margin: 3px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4463ff;
  &:hover {
    background-color: #0046ff;
  }
  && {
    svg {
      color: #fff;
    }
  }
`;

const StyledFormTitle = styled.div`
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 2px;
  padding-left: 5px;
`;

export default observer(Form);
